module.exports = __webpack_public_path__ + "img/supportWhite.07caf139.svg";